<script>
    import { faUpload } from "@fortawesome/free-solid-svg-icons";
    import { createEventDispatcher } from "svelte";
    import Fa from "svelte-fa";

    const dispatch = createEventDispatcher();

    // function select () {
    //     dispatch("select", { item });
    // }

    // let outputDimensions = {x: 200, y: 200}

    let imgInput;
    // let minScale;

    function handleChange (e) {
        if (e.target.files) {
            dispatch("select", {
                file: e.target.files[0]
            })
            // let imageFile = e.target.files[0];
            // var reader = new FileReader();
            // reader.onload = function (e) {
            //     var img = document.createElement("img");
            //     img.onload = function (event) {
            //         // Dynamically create a canvas element
            //         var canvas = document.createElement("canvas");
            //         canvas.width  = outputDimensions.x;
            //         canvas.height = outputDimensions.y;

            //         // var canvas = document.getElementById("canvas");
            //         var ctx = canvas.getContext("2d");

            //         // Actual resizing
            //         const inputDimensions = {x: img.width, y: img.height};
            //         console.log("inputDimensions", inputDimensions);
            //         console.log("outputDimensions", outputDimensions);
            //         // Scale to output and offset to the center
            //         const scale = {
            //             x: outputDimensions.x / inputDimensions.x,
            //             y: outputDimensions.y / inputDimensions.y,
            //         }
            //         minScale = Math.max(scale.x, scale.y);
            //         ctx.drawImage(img, 0, 0, inputDimensions.x*minScale, inputDimensions.y*minScale);

            //         // Show resized image in preview element
            //         var dataurl = canvas.toDataURL(imageFile.type);
            //         document.getElementById("preview").src = dataurl;
            //     }
            //     img.src = e.target.result;
            // }
            // reader.readAsDataURL(imageFile);
        }
    }
</script>

<div class="container">
    <input type="file" id="image-input-x" accept = "image/*" bind:this={imgInput} on:change={handleChange} size="0">
    <label for="image-input-x" class="custom-file-upload">
        <Fa
            icon={faUpload}
        />
    </label>
</div>


<style>
    .container {
        position: relative;
    }

    .container * {
        cursor: pointer;
    }

    input[type="file"]{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        box-sizing: border-box;
        border-width: 0;
        margin: 0;
        opacity: 0;
        z-index: 1;
    }

    input[type="file"]::file-selector-button {
        border: 0;
        padding: 0;
        width: 0;
        height: 0;
        font-size: 0;
        opacity: 0;
    }

    label {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        color: rgba(0, 0, 0, 0.8);
        background-color: #F5F2EF;
    }

    label:hover,
    input:hover + label {
        background-color: #ebe6e2;
    }
</style>
